import {HoldInfo} from "../../holdsQueue/browse/HoldInfo";
import {useGetHoldsQuery} from "../../../../app/apiSlice";

interface HoldInfoTabProps {
    orderId: number
}

export const HoldInfoTab = ({orderId}: HoldInfoTabProps) => {
    const { data: holds, isLoading, refetch } = useGetHoldsQuery(orderId);

    return (
        <HoldInfo
            orderId={orderId}
            holdFlags={holds}
            isLoading={isLoading}
            onShouldRefresh={refetch}
        />
    );
}